<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="12">
        <b-form  onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="keySearch"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="keySearch">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        searchKey: '',
      },
    }
  },
  methods: {
    query() {
      this.$emit('submit', this.form)
    },
    keySearch() {
      this.query()
    },
  },
}
</script>
